import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getHygienePerformanceReport,
  type HygienePerformanceReportResult,
} from '@services/api/reports/operations.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type HygienePerformanceReportData = HygienePerformanceReportResult

export type UseHygienePerformanceReportResult = {
  loading: boolean
  error: string | null
  data: HygienePerformanceReportData | null
  bucketLabel: string
}

export function useHygienePerformanceReport(
  toolbarSelection: Record<string, string>,
): UseHygienePerformanceReportResult {
  const getBucketFromData = useCallback(
    (data: HygienePerformanceReportResult): ReportBucketType =>
      data.hygieneVisits.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getHygienePerformanceReport,
    getBucketFromData,
    errorMessage: 'Failed to load hygiene performance data',
  })
}
